export const environment = {
	production: true,
	url: `https://${window.location.hostname}/api/`,
	apiUrl: `https://${window.location.hostname}/api`,
	auth: {
		url: `https://${window.location.hostname}/auth`,
		realm: "exploration",
		clientId: "frontend-identity-service",
		logoutUri: `https://${window.location.hostname}/sign-out`,
	}
};